(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }
    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }
    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }
    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }
  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() { super(); }
    connectedCallback() {
      super.connectedCallback();
      this.announcementBar = document.querySelector('.shopify-section-announcement-bar');

      // Multiple recalculation points to catch all render timings
      this.positionElements();
      requestAnimationFrame(() => this.positionElements());
      setTimeout(() => this.positionElements(), 50);
      setTimeout(() => this.positionElements(), 200);
      setTimeout(() => this.positionElements(), 500);
      setTimeout(() => this.positionElements(), 1000);

      window.addEventListener('load', () => {
        this.positionElements();
        setTimeout(() => this.positionElements(), 100);
      });
      window.addEventListener('resize', () => this.positionElements());

      // Watch announcement bar for any size changes
      if (this.announcementBar && typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(() => this.positionElements()).observe(this.announcementBar);
      }

      // Watch fonts loading — can change heights
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.positionElements());
      }
    }
    positionElements() {
      const abHeight = this.announcementBar
        ? this.announcementBar.getBoundingClientRect().height
        : 0;
      const headerHeight = this.header.getBoundingClientRect().height;
      this.header.style.top = abHeight + 'px';
      document.body.style.paddingTop = (abHeight + headerHeight) + 'px';
    }
    disconnectedCallback() {
      super.disconnectedCallback?.();
    }
    hide() {}
    reveal() {}
    reset() {}
    sticky() { return true; }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
